export default __webpack_public_path__ + "static/media/biology-and-biopathology.ceffa59d.svg";